import convertToArray from './convertToArray';

class SwitchInputDataTable {
  init() {
    this.doc = document;
    this.inputAttr = 'data-table-input';
    this.saveBtnAttr = 'data-table-save';
    this.rowActiveClass = 'is_active';
    this.able = this.able.bind(this);
    this.save = this.save.bind(this);
  }
  start() {
    this.switchBtnAttr = 'data-table-switch';
    this.switchBtn = convertToArray(document.querySelectorAll(`[${this.switchBtnAttr}]`));
    this.switchBtnLen = this.switchBtn.length;
    if (!this.switchBtn.length) return;
    this.init();
    for (let swi = 0; swi < this.switchBtnLen; swi += 1) {
      this.switchBtn[swi].addEventListener('click', this.able);
    }
  }
  able(e) {
    const current = e.currentTarget;
    const targetRow = current.parentNode.parentNode;
    const targetInput = convertToArray(targetRow.querySelectorAll(`[${this.inputAttr}]`));
    const targetInputLen = targetInput.length;
    for (let ii = 0; ii < targetInputLen; ii += 1) {
      targetInput[ii].disabled = false;
    }
    targetRow.classList.add(this.rowActiveClass);
    const saveBtn = targetRow.querySelector(`[${this.saveBtnAttr}]`);
    saveBtn.addEventListener('click', this.save);
  }
  disable(e) {
    const current = e.currentTarget;
    const targetRow = current.parentNode.parentNode;
    const targetInput = convertToArray(targetRow.querySelectorAll(`[${this.inputAttr}]`));
    const targetInputLen = targetInput.length;
    for (let ii = 0; ii < targetInputLen; ii += 1) {
      targetInput[ii].disabled = true;
    }
    targetRow.classList.remove(this.rowActiveClass);
  }
  save(e) {
    this.disable(e);
  }
}
export default SwitchInputDataTable;



// WEBPACK FOOTER //
// ./src/js/module/SwitchInputDataTable.js